// extracted by mini-css-extract-plugin
export const keyvisual = "index-module--keyvisual--2Pnte";
export const slide = "index-module--slide--2rE3H";
export const fullsize = "index-module--fullsize--2j-ux";
export const background = "index-module--background--34xH7";
export const roundbox = "index-module--roundbox--14BCq";
export const content = "index-module--content--1YUa4";
export const sticky = "index-module--sticky--eMHsu";
export const links = "index-module--links--3QTKg";
export const pager = "index-module--pager--2rlHb";